import React from 'react';
import "./styles.less";
import {usePlatform} from "../../context/PlatformContext";
import {useTranslation} from "react-i18next";
import {useParams} from "react-router-dom";

const LegalInformation = () => {
    const params= useParams()

    const {platform} = usePlatform();
    const {t, i18n} = useTranslation();

    return (<div className={"LegalInformation container"}>
        <h2>{t(`terms.${params.page?.replace("-", "_")}`)}</h2>
        <div dangerouslySetInnerHTML={{__html: platform[params.page?.replace("-", "_")][i18n.language]}} />
    </div>)
}

export default LegalInformation;